import { Flex, Text } from "@fluentui/react-northstar";
import { Card } from "antd";
import React from "react";
import Chart from "react-apexcharts";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";

const AiOverwrite = ({
  aiOverrideRate = {
    currentRate: 14,
    trend: {
      value: -3.2,
      direction: "down",
    },
    breakdown: [
      { status: "Accepted", percentage: 70 },
      { status: "Modified", percentage: 16 },
      { status: "Overridden", percentage: 14 },
    ],
  },
}) => {
  const donutOptions = {
    chart: { type: "donut", sparkline: { enabled: true } },
    colors: ["#10B981", "#F59E0B", "#EF4444"],
    legend: { show: false },
    dataLabels: { enabled: true },
    plotOptions: { pie: { donut: { size: "70%" } } },
    stroke: { width: 0 },
    tooltip: { enabled: true },
  };

  const donutSeries = aiOverrideRate.breakdown
    ? [
        aiOverrideRate.breakdown[0]?.percentage || 0,
        aiOverrideRate.breakdown[1]?.percentage || 0,
        aiOverrideRate.breakdown[2]?.percentage || 0,
      ]
    : [0, 0, 0];
  return (
    <Card style={{ height: "100%", borderRadius: "8px" }} className="shadow">
      <Flex style={{ width: "100%", justifyContent: "space-between" }}>
        <Text content="Ai Overwrite Rate" />
        {!!aiOverrideRate?.trend?.value && (
          <Text
            style={{
              color:
                aiOverrideRate.trend.direction === "up" ? "#EF4444" : "#10B981",
              fontWeight: 500,
            }}
          >
            {aiOverrideRate.trend.direction === "up" ? (
              <ArrowUpOutlined />
            ) : (
              <ArrowDownOutlined />
            )}
            {Math.abs(aiOverrideRate.trend.value)}%
          </Text>
        )}
      </Flex>
      <div style={{ margin: "16px 0 8px 0" }}>
        <Text size="larger" weight="bold" style={{ margin: 0, color: "#222" }}>
          {aiOverrideRate.currentRate}%
        </Text>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Chart
          options={donutOptions}
          series={donutSeries}
          type="donut"
          height={130}
        />
      </div>
    </Card>
  );
};

export default AiOverwrite;
